import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/descadastrar',
  name: 'Descadastrar',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/Descadastrar');
  },
  meta: {
    titulo: 'Descadastrar',
    precisaAutenticacao: false,
    cabecalho: false,
    rodape: false,
    descadastrar: true
  }
}, {
  path: '/descadastrar_whatsapp',
  name: 'Descadastrar Whatsapp',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/Descadastrar');
  },
  props: {
    linkWhatsapp: true
  },
  meta: {
    titulo: 'Descadastrar',
    precisaAutenticacao: false,
    cabecalho: false,
    rodape: false,
    descadastrar: true
  }
}];